import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { FeatureService } from "./feature.service";
import { DOCUMENT } from "@angular/common";

@Injectable({providedIn: "root"})
export class ThemeService {
    private _themePath: ThemePath = 'black-gold-theme';
    private _renderer: Renderer2;

    constructor (
        rendererFactory: RendererFactory2, 
        @Inject(DOCUMENT) private document,
    ) {
        this._renderer = rendererFactory.createRenderer(null, null);
    }

    setTheme(themeName: ThemePath) {
        this._themePath = themeName;
        if (themeName != 'blue-red-theme') {
            const body = this.document.body;
            this._renderer.addClass(body, themeName);
        }
    }

    get themePath() {
        return this._themePath;
    }
}

type ThemePath = 'blue-red-theme' | 'black-gold-theme';